export default __webpack_public_path__ + "static/media/experience.8249f101.svg";